import React from 'react';
import PropTypes from 'prop-types';

import api from 'api';
import { useMountEffect, useUpdateEffect } from 'shared/hooks';

import ConsultTypeNote from './ConsultTypeNote';

const SystemNote = ({ healthSystemId, consultType }) => {
  const [note, setNote] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);

  const fetchNote = React.useCallback(() => {
    if (!healthSystemId) {
      setNote(null);
      return;
    }
    setLoading(true);
    api
      .getHealthSystemNote({
        healthSystemId,
        type: consultType,
      })
      .then(({ data }) => setNote(data.healthSystemNote))
      .catch(() => setNote(null))
      .finally(() => setLoading(false));
  }, [healthSystemId, consultType]);

  useUpdateEffect(() => {
    fetchNote();
  }, [fetchNote]);

  useMountEffect(fetchNote);

  const onUpdateNote = React.useCallback(
    (text) => {
      if (text) {
        if (note) {
          api
            .updateHealthSystemNote({ healthSystemId, type: consultType, text })
            .then(({ data }) => {
              setNote(data);
            });
          return;
        }
        api
          .createHealthSystemNote({
            healthSystemId,
            type: consultType,
            text,
          })
          .then(({ data }) => {
            setNote({
              id: data,
              text,
            });
          });
        return;
      }
      if (note) {
        api
          .deleteHealthSystemNote({ healthSystemId, type: consultType })
          .then(() => setNote(null));
      }
    },
    [note, consultType, healthSystemId],
  );

  return (
    <ConsultTypeNote
      isDisabled={!healthSystemId || isLoading}
      initValue={note?.text ?? ''}
      onUpdate={onUpdateNote}
    />
  );
};

SystemNote.propTypes = {
  consultType: PropTypes.string.isRequired,
  healthSystemId: PropTypes.number,
};

export default SystemNote;
